import moment from "moment";

/**
 * Converts recurring event data from local timezone to UTC.
 * 
 * This function handles the timezone conversion for:
 * 1. Event date/time - converted to UTC datetime
 * 2. Recurring days - weekday numbers shifted to account for UTC day offset
 * 3. End date - converted to UTC datetime with the same time as the event
 * 
 * Example: A 10pm PST Friday game becomes 6am UTC Saturday
 * - Event time: "2024-01-19 22:00" PST → "2024-01-20 06:00" UTC
 * - Recurring day: Friday (4) → Saturday (5) in UTC
 * - End date: "2024-02-16" (Friday) → "2024-02-17 06:00" UTC (Saturday at event time)
 * 
 * @param registerDate - The local date string (YYYY-MM-DD)
 * @param registerStartTime - The local time (dayjs object with $d property)
 * @param recurringDays - Array of weekday numbers (0=Sunday, 1=Monday, etc.)
 * @param recurringEndDate - Optional end date string (YYYY-MM-DD) in local time
 * @returns [recurring_integer, utc_event_time, utc_end_date]
 */
function recurringUTCConverter(
  registerDate: any, 
  registerStartTime: any, 
  recurringDays: number[],
  recurringEndDate?: string
): [string | null, string, string] {
    // Calculate the day offset between local and UTC
    // Using a fixed date to determine if the time crosses midnight in UTC
    const utcDay = moment(
        moment(
          "2024-01-15T" + moment(registerStartTime["$d"]).format("HH:mm")
        ).format("YYYY-MM-DDTHH:mm")
      )
        .utc()
        .format("DDD");
      const localDay = moment(
        moment(
          "2024-01-15T" + moment(registerStartTime["$d"]).format("HH:mm")
        ).format("YYYY-MM-DDTHH:mm")
      ).format("DDD");
      const offSet = Number(utcDay) - Number(localDay);

      // Convert recurring days to UTC weekdays
      let recurring_integer: string | null = null;
      if (recurringDays.length !== 0) {
        for (let index = 0; index < recurringDays.length; index++) {
          const utcWeekDay = (((recurringDays[index] + offSet) % 7) + 7) % 7;
          console.log("UTC WEEK Day");
          console.log(utcWeekDay);
          if (!recurring_integer) {
            recurring_integer = utcWeekDay.toString();
          } else {
            recurring_integer += "_" + utcWeekDay.toString();
          }
          console.log(recurring_integer);
        }
      }
      
      // Convert event date/time to UTC
      console.log("UTC TIME");
      console.log(recurring_integer);
      console.log(moment(
        registerDate + " " + moment(registerStartTime["$d"]).format("HH:mm")
      ))
      const utc_event_time = moment(
        registerDate + " " + moment(registerStartTime["$d"]).format("HH:mm")
      )
        .utc()
        .format("YYYY-MM-DD HH:mm");
      console.log(utc_event_time);
      
      // Convert end date to UTC (combine with event time, then convert)
      // This ensures the end date includes the last occurrence even if it crosses midnight in UTC
      let utc_end_date = "";
      if (recurringEndDate) {
        // Combine end date with event time in local timezone, then convert to UTC
        const localEndDateTime = moment(
          recurringEndDate + " " + moment(registerStartTime["$d"]).format("HH:mm")
        );
        utc_end_date = localEndDateTime.utc().format("YYYY-MM-DD HH:mm");
        console.log("UTC END DATE:", utc_end_date);
      }
      
    return [recurring_integer, utc_event_time, utc_end_date]
}

export default recurringUTCConverter